import React from "react";
import SkeletonBox from "./skeleton";

const HeaderSkeleton = ({ shouldShowNav }: { shouldShowNav: boolean }) => {
    return (
        <div
            className={`${shouldShowNav ? "flex" : "hidden"} sticky top-0 z-50 bg-white h-[68px] w-full items-center justify-center md:h-24`}
        >
            <div className="relative flex w-full gap-s6 px-4 sm:container md:px-0">
                <div className="flex w-full items-center justify-between py-s8 md:mx-s10">
                    <div className="flex flex-1 gap-20">
                        <SkeletonBox classname="h-[42px] w-[90px] sm:h-[42px] sm:w-[119px]" />
                        <div className="hidden flex-1 gap-s8 self-center sm:flex">
                            {[...Array(8)].map((_, index) => (
                                <SkeletonBox key={index} classname="h-6 w-16" index={index} />
                            ))}
                        </div>
                    </div>
                    <div className="flex items-center gap-s5 pr-s3">
                        <SkeletonBox classname="h-8 w-24" />
                        <SkeletonBox classname="h-8 w-24 hidden md:block" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeaderSkeleton;
